__turbopack_context__.v({
  "img": "GallerySlideInner-module-scss-module__cpd6Na__img",
  "imgFull": "GallerySlideInner-module-scss-module__cpd6Na__imgFull",
  "imgWrapper": "GallerySlideInner-module-scss-module__cpd6Na__imgWrapper",
  "imgWrapperFull": "GallerySlideInner-module-scss-module__cpd6Na__imgWrapperFull",
});
